import { render } from "./CaseFile.vue?vue&type=template&id=3c4d0762&scoped=true"
import script from "./CaseFile.vue?vue&type=script&lang=js"
export * from "./CaseFile.vue?vue&type=script&lang=js"

import "./CaseFile.vue?vue&type=style&index=0&id=3c4d0762&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4d0762"]])

export default __exports__